// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__i9ch-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2sTnl"};